import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=351cc39d&scoped=true&"
import script from "./StatusBar.vue?vue&type=script&lang=js&"
export * from "./StatusBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=351cc39d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351cc39d",
  null
  
)

component.options.__file = "StatusBar.vue"
export default component.exports